export const passwordRoute = {
  path: "/password",
  component: () => import("@/views/password/index.vue"),
};
